/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import React from 'react'
import { fmt, show, hideModal, showModal, cleanObject, isEmpty } from '../../twd/twd'

export default ({rows, title, searchParams, sort, from, acctNo}) => {

    const p = { sort, searchParams, title, from}
    return <div className="table-responsive vertical-offset-sm"
        style={{display:"block", maxHeight:"450px",}}
    >
    <table
        data-name="offerings-modal-table"
        className="table align-top">
        <thead>
        <tr>
        <th><SortLink {...p} field='holdCusip'>CUSIP</SortLink></th>
        <th><SortLink {...p} field='holdMaturitySortDt'>Maturity date</SortLink></th>
        <th className="text-right"><SortLink {...p} field='askPrice'>Price</SortLink></th>
        <th className="text-right"><SortLink {...p} field='holdCoupon'>Coupon</SortLink></th>
        <th className="text-right"><SortLink {...p} field='askYield'>Yield</SortLink></th>
        <th>
            <SortLink {...p} field='moodyRating'>Moody's</SortLink> / <SortLink {...p} field='spRating'>S&amp;P</SortLink>
        </th>
        <th>Callable</th>
        <th>Action</th>
        </tr>
    </thead>
    <tbody>{
        rows && rows.map( (r,i) => {
            let isMBS = ['O', 'R', 'K'].indexOf(r.holdInvType)>=0
            let isCallable = !isMBS && !isEmpty(r.holdFirstCall)
            return <tr
                data-name="offerings-modal-row"
                key={i}>
            <td className="text-bold"><a href='#'
                type="button"
                data-name="offerings-modal-cusip-link"
                style={{cursor:'pointer'}}
                onClick={() => {
                    hideModal()
                    show('bond-detail', { cusip: r.holdCusip, from })
                }}
            >{r.holdCusip}</a></td>
            <td>{r.holdMaturity}</td>
            <td className="text-right">
                {askItem(fmt.price(r.askPrice))}
                <br/>
                {bidItem(fmt.price(r.bidPrice))}
            </td>
            <td className="text-right">{fmt.cpn(r.holdCoupon)}</td>
            <td className="text-right">
                {askItem(formatYield(r.askYield, r.askYtwInd))}
                <br/>
                {bidItem(formatYield(r.bidYield, r.bidYtwInd))}
            </td>
            <td>{r.moodyRating || fmt.empty()} / {r.spRating || fmt.empty()}</td>
            <td>{isCallable ? 'Yes' : 'No'}</td>
            <td className="text-center" style={{maxWidth:'45px', verticalAlign:'middle'}}>
                {formatOrder(r, acctNo)}
            </td>
            </tr>
        })
    }</tbody>
    </table>
    </div>
}


const SortLink = ({title, searchParams, field, sort, from, children}) => {

    let {field:sortField, direction:sortDirection} = (sort || {field:'askYield', direction:'DESC'})
    let isSorted = field===sortField
    let isAsc = sortDirection==='ASC'
    return <React.Fragment>
    <button
        data-name="search-modal-header-sort"
        data-field={field}
        data-direction={isSorted && isAsc ? 'DESC' : 'ASC'}

        className="btn-link text-body"
        style={{cursor:'pointer', color:'#767676', whiteSpace:'nowrap' }}
        onClick={() => {
            let direction = isSorted && isAsc ? 'DESC' : 'ASC'
            onSortChange(title, searchParams, from, {field, direction})
        }}
    >
    {children}
    {isSorted && (
        sortDirection==='ASC'
        ? <i className="material-icons">arrow_drop_up</i>
        : <i className="material-icons">arrow_drop_down</i>)}

    </button>
    </React.Fragment>
}


const onSortChange = (title, searchParams, from, {field, direction}) => {
    const ps = {...(searchParams || {})}
    ps.sort = [{field, direction}]
    showModal({
        view:'order-ticket-search-modal',
        searchParams: cleanObject(ps),
        title,
        sort: {field, direction},
        from,
        _ts: Date.now(),
    })
}

const askItem = (txt) => <span style={{color:'green'}}>{txt}</span>
const bidItem = (txt) => <span style={{color:'red'}}>{txt}</span>

const formatYield = (val, ind) => {
    let x = Number.parseFloat(val)
    if (isNaN(x)) return fmt.empty()

    let y = fmt.ytw(x)
    if (!ind) return y
    ind = ind.toLowerCase()
    if (['c','dis','f','n','p','r','t','w'].indexOf(ind)<0) return y

    return <React.Fragment>{y} ({ind})</React.Fragment>
}

const formatOrder = (r, acctNo) => {
    if (r.allowTrading===false) return fmt.orderPhone()

    return <React.Fragment>
        <div>
        {r.askQuantity && fmt.buy({acctNo, cusip:r.holdCusip, extraClassName:'vertical-offset-xxs'})}
        {!r.askQuantity && <br/> }
        </div>
        <div>
        {r.bidQuantity && fmt.sell({acctNo, cusip:r.holdCusip, qty:r.bidQuantity })}
        </div>
    </React.Fragment>
}
